var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMore = function SvgMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6577 10.7986C21.6577 16.5976 16.9567 21.2986 11.1577 21.2986C5.35871 21.2986 0.6577 16.5976 0.6577 10.7986C0.6577 4.99961 5.35871 0.298599 11.1577 0.298599C16.9567 0.298599 21.6577 4.99961 21.6577 10.7986ZM12.6577 5.79858C12.6577 6.62701 11.9861 7.29858 11.1577 7.29858C10.3293 7.29858 9.6577 6.62701 9.6577 5.79858C9.6577 4.97015 10.3293 4.29858 11.1577 4.29858C11.9861 4.29858 12.6577 4.97015 12.6577 5.79858ZM11.1577 12.2986C11.9861 12.2986 12.6577 11.627 12.6577 10.7986C12.6577 9.97017 11.9861 9.2986 11.1577 9.2986C10.3293 9.2986 9.6577 9.97017 9.6577 10.7986C9.6577 11.627 10.3293 12.2986 11.1577 12.2986ZM12.6577 15.7986C12.6577 16.627 11.9861 17.2986 11.1577 17.2986C10.3293 17.2986 9.6577 16.627 9.6577 15.7986C9.6577 14.9702 10.3293 14.2986 11.1577 14.2986C11.9861 14.2986 12.6577 14.9702 12.6577 15.7986Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more.e3ae29ec.svg";
export { ForwardRef as ReactComponent };